<template>
  <div class="">
    <v-select
      v-model="userList"
      :options="userListOptions"
      :clearable="false"
      multiple
      @input="onChange"
      @search="onSearch"
      :disabled="isSelectDisabled"
      :selectable="(option) => userList.length < maxLength"
    />
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";
import {debounce} from "lodash";
import axios from "@axios";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    fieldOptions: Object,
    context: Object
  },
  setup(props, { emit }) {
    const maxLength = ref(1000);
    const search = ref("");
    const limit = ref(8);
    const userList = ref(false);
    const options = ref(null);
    const isSelectDisabled = ref(false);
    const userListOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.id,
        label: `${u.username} | ${u.full_name}`,
      }))
    );

    // TODO: Move this to field configuration
    // Get the template name from the HTML
    const htmlObj = document.querySelector("div.header-grid.mb-1 > div > div.row > div > div:nth-child(2) > span.info-value");
    const templateNames = ref([
      'Proyectos CCB - Reporte de hallazgos',
      'BAU Mantenimiento - Asesorías',
      'BAU Mantenimiento - Reforzamiento de seguridad',
      'Fallas no imputables a seguridad',
    ]);
    const isMaintenanceForm = ref(false);
    isMaintenanceForm.value = templateNames.value.includes(htmlObj.textContent);
    const ccbMaintenanceProfiles = ref([
      'SuperAdmin',
      'Analista_SopTecProy',
      'supervisor_soporte_proyectos',
      'operador_soporte_tecnico_bau',
      'Supervisor_Soporte_Tecnico',
      'Analista_SopTecProy',
    ]);

    onMounted(() => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      userList.value = props.context.model
      maxLength.value = props.fieldOptions.fieldTypeCfg?.data[0]?.maxLength ?? maxLength.value
      fetchData()
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          userList.value = newValue
        }
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get("/v1/users", {
          params: {
            q: search.value,
            max: limit.value,
            sortBy: 'id',
            'with[]': 'profile',
            profiles: isMaintenanceForm.value ? ccbMaintenanceProfiles.value : null,
          },
        });
        options.value = data.data;
      } catch (error) {
        console.error(`UserList: request error`, error?.response || error);
      }
    }

    async function onChange(value) {
      props.context.model = value
    }

    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        await fetchData();
        loading(false);
      } else {
        search.value = '';
        await fetchData();
      }
    }, 500);

    return {
      userList,
      userListOptions,
      isSelectDisabled,
      maxLength,
      onSearch,
      onChange
    }
  }
}
</script>
